import React, { useMemo, createContext, useEffect, useState } from "react";
import HeaderBanner from "@/organisms/common/HeaderBanner";
import Header from "@/organisms/common/Header";
import Footer from "@/organisms/common/Footer";
import SEO from "@/organisms/common/SEO";
import CookieBanner from "@/organisms/common/CookieBanner";
import { isRegisteredUser } from "@/utils/commonUtil";
import { TreeCountSection } from "./organisms/common/TreeCountSection";
import { getTreeCount } from "@/utils/treeCountService";

export const GlobalContext = createContext(null);

export default function Theme({
  seo,
  header,
  hero,
  footer,
  mainClassName,
  hasSidebar,
  showBanner = true,
  headerClassName,
  headerVariant,
  hasHeaderCta,
  hasFooter = true,
  isFooterMini = false,
  isWhiteHeader = false,
  children,
  hasTopAudioBannerLP = false,
  refMain,
  ...props
}) {
  const [globalState, setGlobalState] = useState({
    isRegistered: false,
  });

  const [treeCount, setTreeCount] = useState("1,726,971");
  useEffect(() => {
    getTreeCount().then(setTreeCount);
  }, []);

  useEffect(() => {
    const updateRegisteredStateIfRequired = () => {
      const isRegisteredCookiePresent = isRegisteredUser();
      if (!globalState?.isRegistered && isRegisteredCookiePresent) {
        setGlobalState({ isRegistered: isRegisteredCookiePresent });
      }
    };

    updateRegisteredStateIfRequired();
    window.addEventListener("pageshow", updateRegisteredStateIfRequired);

    return () => {
      window.removeEventListener("pageshow", updateRegisteredStateIfRequired);
    };
  }, [globalState?.isRegistered]);

  return (
    <GlobalContext.Provider
      value={useMemo(
        () => [globalState, setGlobalState, treeCount],
        [globalState, setGlobalState, treeCount]
      )}
    >
      {seo && <SEO data={seo} />}
      <div className={`webpage ${hasSidebar ? "is-sidebar" : ""}`}>
        <HeaderBanner />
        <Header
          className={headerClassName}
          data={header}
          variant={headerVariant}
          isWhiteHeader={isWhiteHeader}
          hasHeaderCta={hasHeaderCta}
          {...props}
        />
        <CookieBanner showBanner={showBanner} />
        {hero}
        <main
          className={`${
            hasTopAudioBannerLP
              ? "scroll-offset--audio-banner"
              : "scroll-offset--default"
          } ${mainClassName}`}
          ref={refMain}
        >
          {children}
          <TreeCountSection />
          {hasFooter && <Footer isFooterMini={isFooterMini} />}
        </main>
      </div>
    </GlobalContext.Provider>
  );
}
